import React, { useState } from "react";
import Theme from "../../Theme/Theme";
import CustomDivider from "../../Utils/CustomDivider/CustomDivider";
import styled from "styled-components";
import Lable from "../Lable/Lable";
import { AllEmployeesData } from "../../Utils/Data";
import AllEmployeesTable from "../All-Employees-Table/AllEmployeesTable";

export default function AllEmployees() {
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(5);

  const [LableInfo] = useState(AllEmployeesData);

  const [Header] = useState([
    "ردیف",
    "نام و نام خانوادگی",
    "مسئولیت",
    "وضعیت",
    "عملیات",
  ]);

  const width = ["15rem", "18rem", "24rem", "18rem", "18rem"];
  const lastPostIndex = currentPage * postsPerPage;
  const firstPostIndex = lastPostIndex - postsPerPage;

  const nextPageHandler = function () {
    setCurrentPage((data) => {
      if (LableInfo?.length > (data + 1) * postsPerPage - postsPerPage)
        return ++data;

      return data;
    });
  };

  const previousPageHandler = function () {
    setCurrentPage((data) => {
      if (currentPage > 1) return --data;

      return data;
    });
  };
  return (
    <Container>
      <TitleElement>
        <ImgContainer>
          <TitleIcon src="/Assets/Images/NavigatorIcons/AllEmployeeIcon/Grey.svg"></TitleIcon>
        </ImgContainer>
        <TitleText>درخواست های برسی</TitleText>
      </TitleElement>
      <CustomDivider></CustomDivider>
      <HeaderContainer>
        <SearchContainer>
          <TextContainer>
            <LableText>نام و نام خانوادگی :</LableText>
            <LableInput />
          </TextContainer>
          <SearchButton>
            جست و جو
            <SearchIcon src="/Assets/Images/Search.svg" />
          </SearchButton>
        </SearchContainer>
        <AddEmployeeButton>
          افزودن کارمند
          <AddEmployeeIcon src="/Assets/Images/AddEmployee.svg" />
        </AddEmployeeButton>
      </HeaderContainer>

      <TableContainer>
        <ListContainer>
          <Lable props={{ ...Header }} width={width} />
          {LableInfo.slice(firstPostIndex, lastPostIndex).map((data) => {
            return (
              <AllEmployeesTable
                key={data.id}
                props={{ ...data }}
                width={width}
              />
            );
          })}
        </ListContainer>
        <ListButton>
          <Icon
            src="/Assets/Images/prePage.svg"
            onClick={() => previousPageHandler()}
          ></Icon>
          <Text>{`صفحه ${currentPage} از ${Math.ceil(
            LableInfo?.length / postsPerPage
          )}`}</Text>
          <Icon
            src="/Assets/Images/nextPage.svg"
            onClick={() => nextPageHandler()}
          ></Icon>
        </ListButton>
      </TableContainer>
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  direction: rtl;
  box-sizing: border-box;
  padding: 5px;
`;

const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const HeaderContainer = styled.div`
  width: 98%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ListContainer = styled.div`
  width: 100%;
  display: block;
`;

const SearchContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: start;
`;

const TitleElement = styled.p`
  width: 100%;
  height: 30px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const ImgContainer = styled.div`
  width: 38px;
  height: 38px;
  border: 1px solid #f5f7f8;
  background-color: transparent;
  border-radius: ${Theme.borderRadius};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const TitleIcon = styled.img`
  object-fit: contain;
`;

const TitleText = styled.p`
  height: 40px;
  font-size: ${Theme.fontTitleSize};
  font-weight: ${Theme.fontInfoWeight};
  line-height: 41px;
  box-sizing: border-box;
  padding-inline: 20px;
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  margin: 1rem 2rem 0rem 3rem;
`;

const LableText = styled.label`
  color: ${Theme.colorFontBlack};
  font-size: ${Theme.fontSiz};
  font-weight: ${Theme.fontWeigh};
  margin: 10px 0;
`;

const LableInput = styled.input`
  background-color: ${Theme.colorBackgroundBox};
  color: ${Theme.colorFontBlack};
  padding: 8px 12px;
  border: 1px solid ${Theme.colorBorderTextField};
  border-radius: ${Theme.borderRadius};
  width: 240px;
  font-size: ${Theme.fontSiz};
  font-weight: ${Theme.fontInfoSize};
  font-family: "IranSans";

  &:focus {
    outline: none;
    box-shadow: 0px 0px 2px ${Theme.colorFontBlack};
  }
`;

const SearchIcon = styled.img`
  position: absolute;
  left: 12px;
  top: 10px;
  transition: all 500ms ease;
`;

const SearchButton = styled.button`
  background-color: ${Theme.colorBluePrimary};
  color: ${Theme.colorFontWhite};
  border-radius: ${Theme.borderRadius};
  padding: 8px 12px;
  margin: 3.8rem 0 1.5rem;
  width: 170px;
  border: none;
  font-size: ${Theme.fontSiz};
  font-weight: ${Theme.fontInfoSize};
  font-family: "IranSans";
  height: fit-content;
  position: relative;
  transition: all 500ms ease;
  cursor: pointer;
  text-align: center;
  overflow: hidden;

  &::before {
    content: "";
    background-color: #03a9f4;
    position: absolute;
    transform: skewX(30deg);
    width: 10%;
    height: 100%;
    top: 0;
    right: -20px;
    opacity: 0.5;
    transition: all 500ms ease;
  }

  &:hover {
    ${SearchIcon} {
      left: 15px;
    }
    word-spacing: 1px;
    transform: translateY(-3px);
  }

  &:hover::before {
    right: 110%;
  }
`;

const AddEmployeeIcon = styled.img`
  position: absolute;
  left: 12px;
  top: 8px;
  transition: all 500ms ease;
`;

const AddEmployeeButton = styled.button`
  background-color: transparent;
  color: ${Theme.colorBluePrimary};
  border-radius: ${Theme.borderRadius};
  padding: 8px 12px;
  margin: 3.8rem 0 1.5rem;
  width: 170px;
  border: 1px solid ${Theme.colorBluePrimary};
  font-size: ${Theme.fontSiz};
  font-weight: ${Theme.fontWeight};
  font-family: "IranSans";
  height: fit-content;
  position: relative;
  transition: all 500ms ease;
  cursor: pointer;
  text-align: center;
  overflow: hidden;

  &::before {
    content: "";
    background-color: #03a9f4;
    position: absolute;
    transform: skewX(30deg);
    width: 10%;
    height: 100%;
    top: 0;
    right: -20px;
    opacity: 0.05;
    transition: all 500ms ease;
  }

  &:hover {
    ${SearchIcon} {
      left: 15px;
    }
    word-spacing: 1px;
    transform: translateY(-3px);
  }

  &:hover::before {
    right: 110%;
  }
`;

const ListButton = styled.button`
  margin: 0.5rem auto;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: ${Theme.colorBluePrimary};
  border-radius: ${Theme.borderRadius};
  border: none;
  padding: 0.5rem;
`;

const Icon = styled.img`
  width: 1rem;
  height: 1rem;
  margin: 0.7rem;
  cursor: pointer;
`;

const Text = styled.p`
  font-family: "IranSans";
  font-size: ${Theme.fontInfoSize};
  font-weight: ${Theme.fontWeigh};
  color: ${Theme.colorFontWhite};
  margin: 0;
  padding: 0 1rem;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  border-left: 1px solid rgba(255, 255, 255, 0.3);
`;
